import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Log from './log';
import LogDetail from './log-detail';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={LogDetail} />
      <ErrorBoundaryRoute path={match.url} component={Log} />
    </Switch>
  </>
);

export default Routes;
